var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chest_armor",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.49,13.55c-1.06-1.51-4.05-5.05-9.52-6.49c-0.35-0.09-0.72,0.14-0.78,0.5c-0.35,2.04-1.78,8.08-6.69,8.08 s-6.34-6.04-6.69-8.08c-0.06-0.36-0.43-0.59-0.78-0.5c-5.47,1.44-8.46,4.98-9.52,6.49c-0.24,0.34-0.09,0.8,0.3,0.94 c2.01,0.7,7.34,2.94,7.34,7.01c0,4.24-4.47,6.89-5.87,7.61c-0.25,0.13-0.38,0.4-0.33,0.67c1.44,7.62,7.55,13.09,8.67,14.04 c0.11,0.1,0.25,0.15,0.4,0.15h6.47h6.47c0.15,0,0.29-0.05,0.4-0.15c1.12-0.95,7.23-6.42,8.67-14.04c0.05-0.27-0.08-0.54-0.33-0.67 c-1.4-0.72-5.87-3.37-5.87-7.61c0-4.08,5.33-6.32,7.34-7.01C42.58,14.35,42.73,13.88,42.49,13.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChest);
export default __webpack_public_path__ + "static/media/chest.3a06f1b09d44a74ff6df45811c3ae1ac.svg";
export { ForwardRef as ReactComponent };